import React from 'react';
import { Button } from 'components/ui/button';

interface ProcessorActionButtonProps {
  isEnabled: boolean | null;
  isDeleted: boolean;
  onDelete: () => Promise<void>;
  onActivate: () => Promise<void>;
  disabled?: boolean;
}

export const ProcessorActionButton: React.FC<ProcessorActionButtonProps> = ({
  isEnabled,
  isDeleted,
  onDelete,
  onActivate,
  disabled = false,
}) => {
  const showActivateButton = isDeleted || isEnabled === null;

  if (showActivateButton) {
    return (
      <Button
        variant="primary-outline"
        rounded="sm"
        disabled={disabled}
        onClick={onActivate}
        className="h-8 w-20"
      >
        Activate
      </Button>
    );
  }

  return (
    <Button
      variant="destructive-outline"
      rounded="sm"
      disabled={disabled}
      onClick={onDelete}
      className="h-8 w-20"
    >
      Delete
    </Button>
  );
};
